import { secondary } from "../../../../assets/variables.module.scss";

const styles = (theme) => ({
  toolbarContainer: {
    paddingLeft: theme.spacing(0.75),
  },
  filtersContainer: {
    height: 36,
  },
  button: {
    textTransform: "capitalize",
    color: secondary,
    marginLeft: theme.spacing(1),
    display: "flex",
    alignItems: "center",

    "&:hover": { backgroundColor: "transparent" },

    "& svg": {
      marginRight: theme.spacing(1),
      color: secondary,
      width: 15,
      height: 15,
    },
  },
  selectContainer: {
    display: "flex",
    alignItems: "center",
  },
  select: {
    marginBottom: -6,
  },
});

export default styles;
